import { FormService } from './FormService';

export class FoilingEmbossingNcrService extends FormService {
    constructor() {
        super("FoilingEmbossingNcrs");
    }
}